import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiClipboardTextOutline } from '@mdi/js';
import { FaCheck } from 'react-icons/fa6';
import { mapSolveTypeEnumToStrings } from '../../../constants/AnnuitiesSolveTypes';

/**
 * AnnuityFormSection Component
 * Form fields specific to annuity quotes
 */
const AnnuityFormSection = ({ formData, onInputChange, onModalOpen, styles, aaqCriteriaOptions, solveType, getAnnuitySolveOptions }) => {
  const toggleItem = (arr, item) => (arr.includes(item) ? arr.filter(x => x !== item) : [...arr, item]);

  return (
    <div style={styles.column}>
      <div style={styles.columnHeader}>Annuity Details</div>

      {/* Product Type */}
      <div style={styles.formGroup} data-itemid='annuity-product-type-wrapper'>
        <div style={styles.row} data-itemid='annuity-product-type-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-product-type-label'>
            Product Type
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-product-type-label-required'>
            *
          </label>
        </div>
        <div style={styles.buttonGroup} data-itemid='annuity-product-type-button-group'>
          {aaqCriteriaOptions?.product_types?.map(type => (
            <button
              key={type}
              onClick={() => {
                const current = formData.productTypes || [];
                onInputChange('productTypes', toggleItem(current, type));
              }}
              style={styles.button((formData.productTypes || []).includes(type))}
              type='button'
              data-itemid={`annuity-product-type-button-${type}`}
            >
              {type}
              {(formData.productTypes || []).includes(type) && <FaCheck data-itemid={`annuity-product-type-button-${type}-check`} />}
            </button>
          ))}
        </div>
      </div>

      {/* Tax Treatment */}
      <div style={styles.formGroup} data-itemid='annuity-tax-treatment-wrapper'>
        <label style={styles.label} data-itemid='annuity-tax-treatment-label'>
          Tax Treatment
        </label>
        <div style={styles.buttonGroup} data-itemid='annuity-tax-treatment-button-group'>
          {['Qualified', 'Non-Qualified'].map(treatment => (
            <button
              key={treatment}
              onClick={() => onInputChange('taxTreatment', treatment)}
              style={styles.button(formData.taxTreatment === treatment)}
              type='button'
              data-itemid={`annuity-tax-treatment-button-${treatment}`}
            >
              {treatment}
              {formData.taxTreatment === treatment && <FaCheck data-itemid={`annuity-tax-treatment-button-${treatment}-check`} />}
            </button>
          ))}
        </div>
      </div>

      {/* Premium */}
      <div style={styles.formGroup} data-itemid='annuity-premium-wrapper'>
        <div style={styles.row} data-itemid='annuity-premium-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-premium-label'>
            Premium
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-premium-label-required'>
            *
          </label>
        </div>
        <input
          onChange={e => onInputChange('premiumAnnuity', e.target.value)}
          placeholder='150000'
          style={styles.input}
          type='number'
          value={formData.premiumAnnuity || ''}
          data-itemid='annuity-premium-input'
        />
      </div>

      {/* Solve For */}
      <div style={styles.formGroup} data-itemid='annuity-solve-for-wrapper'>
        <label style={styles.label} data-itemid='annuity-solve-for-label'>
          Solve For
        </label>
        <select onChange={e => onInputChange('solveFor', e.target.value)} style={styles.select} value={formData.solveFor || ''} data-itemid='annuity-solve-for-select'>
          <option value='' data-itemid='annuity-solve-for-option-empty'>
            Select Solve Type
          </option>
          {getAnnuitySolveOptions &&
            getAnnuitySolveOptions().map(option => (
              <option key={option.value} value={option.value} data-itemid={`annuity-solve-for-option-${option.value}`}>
                {option.label}
              </option>
            ))}
        </select>
      </div>

      {/* Carriers */}
      <div style={styles.formGroup} data-itemid='annuity-carriers-wrapper'>
        <div style={styles.row} data-itemid='annuity-carriers-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-carriers-label'>
            Carriers
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-carriers-label-required'>
            *
          </label>
        </div>
        <button
          onClick={() => onModalOpen('carriers')}
          style={{ ...styles.carriersButton, display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
          type='button'
          data-itemid='annuity-carriers-button'
        >
          <Icon path={mdiClipboardTextOutline} size={0.7} data-itemid='annuity-carriers-button-icon' />
          Select Carriers ({(formData.selectedCarriers || []).length} Selected)
        </button>
      </div>
    </div>
  );
};

AnnuityFormSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onModalOpen: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  aaqCriteriaOptions: PropTypes.object.isRequired,
  solveType: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  getAnnuitySolveOptions: PropTypes.func
};

export default AnnuityFormSection;
